module.exports = require("././angular-sanitize.js");


//////////////////
// WEBPACK FOOTER
// angular-sanitize (bower component)
// module id = 411
// module chunks = 1